import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Overline } from "../components/Overline";
import { Button } from "../components/ui/button";
import { Seo } from "../components/Seo";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const token = params.get("token") || "";
  const [state, setState] = useState("processing");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!email || !token) {
      setState("error");
      setMessage("This unsubscribe link is incomplete.");
      return;
    }
    api
      .get(`/unsubscribe?email=${encodeURIComponent(email)}&token=${token}`)
      .then((r) => {
        setState(r.data.ok ? "ok" : "error");
        setMessage(r.data.message);
      })
      .catch(() => {
        setState("error");
        setMessage("Something went wrong. Please email lara@aimawomenshealth.com to be removed.");
      });
  }, [email, token]);

  return (
    <div data-testid="page-unsubscribe" className="bg-[#faf9f6] min-h-[70vh] flex items-center">
      <Seo title="Unsubscribe" description="Manage your Aima Women's Health email preferences." path="/unsubscribe" />
      <section className="max-w-2xl mx-auto px-6 md:px-12 py-20 text-center">
        <Overline>{state === "ok" ? "All done" : state === "error" ? "" : "One moment"}</Overline>
        <h1 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.05] font-normal text-[#333] mt-5">
          {state === "ok" && (
            <>
              You've been
              <br />
              <span className="italic">quietly unsubscribed.</span>
            </>
          )}
          {state === "error" && (
            <>
              Hmm, something
              <br />
              <span className="italic">didn't quite work.</span>
            </>
          )}
          {state === "processing" && "Unsubscribing you..."}
        </h1>
        <p className="mt-6 text-lg text-[#3d3d3d] font-normal leading-relaxed">{message}</p>
        {state === "ok" && (
          <p className="mt-3 text-base text-[#5a5a5a] font-normal">
            No more emails from me. Your download and the guide link remain yours to keep.
          </p>
        )}
        <Link to="/" className="inline-block mt-10">
          <Button className="bg-[#5fa292] hover:bg-[#4d8275] text-white rounded-full px-8 h-12">
            Return to the site
          </Button>
        </Link>
      </section>
    </div>
  );
}
